(ns minorodata.components.connections.forms.conditionals-v2
  (:require [cljs.reader :as reader]
            [clojure.string :as str]
            ["date-fns" :refer [differenceInDays]]))

(defmulti resolve-condition
          (fn [_ condition-data]
            (when (sequential? condition-data)
                (first condition-data))))

(defmethod resolve-condition :default [_ condition-data]
  condition-data)

(defmethod resolve-condition :eq [fields [_ & opts]]
  (apply = (mapv (partial resolve-condition fields) opts)))

(defmethod resolve-condition :gt [fields [_ & opts]]
  (apply > (mapv (partial resolve-condition fields) opts)))

(defmethod resolve-condition :lt [fields [_ & opts]]
  (apply < (mapv (partial resolve-condition fields) opts)))

(defmethod resolve-condition :dt-diff [fields [_ & opts]]
  (differenceInDays (resolve-condition fields (second opts)) (resolve-condition fields (first opts))))

(defmethod resolve-condition :not [fields [_ & opts]]
   (not (apply resolve-condition fields opts)))

(defmethod resolve-condition :nil? [fields [_ & opts]]
   (nil? (apply resolve-condition fields opts)))

(defmethod resolve-condition :blank [fields [_ & opts]]
   (str/blank? (apply resolve-condition fields opts)))

(defmethod resolve-condition :or [fields [_ & opts]]
   (boolean (some identity (mapv (partial resolve-condition fields) opts))))

(defmethod resolve-condition :and [fields [_ & opts]]
  (boolean (every? identity (mapv (partial resolve-condition fields) opts))))

(defmethod resolve-condition :val [fields [_ & opts]]
  (let [[path coerce-opt] opts
        value (get-in fields [path :value])]
    (case coerce-opt
      :num (reader/read-string value)
      value)))
